import React from 'react';
import { EDITED_AFTER_REVIEW_LABEL } from '../../utils/brand-deal-content';

/** Nhãn ở trang admin cho đơn có nội dung đổi sau khi chiến dịch được duyệt (spec 2026-10-12 §5.1, quyết định lọc tự động và gắn cờ). */
const EditedAfterReviewBadge: React.FC = () => (
  <span className="mt-0.5 inline-flex rounded-full bg-amber-100 px-2 py-0.5 text-[11px] font-semibold text-amber-700 dark:bg-amber-900/30 dark:text-amber-300">
    {EDITED_AFTER_REVIEW_LABEL}
  </span>
);

export default EditedAfterReviewBadge;
